// extracted by mini-css-extract-plugin
export default {"logoInLine":"aboutTable_logoInLine__qiPhI"};